import axiosInstance from "../config/axiosInstance";
import { APIROUTE } from "../config/config";

export const createExpenseService = async (payload) => {
  return (await axiosInstance.post(APIROUTE.expense, payload)).data;
};

export const getExpenseService = async (signal) => {
  return (await axiosInstance.get(`${APIROUTE.expense}`, signal)).data; 
}

export const updateExpenseService = async (payload) => {
  let filteredPayload = {
    "expenseId" : payload.expenseId,
    "userId": payload.userId,
    "amount": payload.amount,
    "description": payload.description,
    "expenseDate": payload.expenseDate,
  }
  return (await axiosInstance.put(`${APIROUTE.expense}/${payload.expenseId}`, filteredPayload)).data;
};